import { render, staticRenderFns } from "./more.vue?vue&type=template&id=82dd0d64&"
import script from "./more.vue?vue&type=script&lang=js&"
export * from "./more.vue?vue&type=script&lang=js&"
import style0 from "./more.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports